import './style/SiteFooter.css';

import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import WordmarkBlack from '../../media/materialize-logo-wordmark-black.png';
import WordmarkWhite from '../../media/materialize-logo-wordmark-white.png';
import Divider from './Divider';
import { Navigate, Text } from '@harperai/materialize-design-system';

const SiteFooter = ({ bgColor = "white", bumpForCookieFooter = true }) => {
    const local = useSelector((state) => state.local);
    const navigate = useNavigate();

    const logo = bgColor === "black" ? WordmarkWhite : WordmarkBlack;

    return (
        <div className="flex pad-m no-pad-bot">
            <div className={`white-bg flex vertical flex-1 gap-xl pad-xl ${(local?.cookies === "unset" && bumpForCookieFooter) ? "cookie-banner-bump" : ""}`} style={{borderTopLeftRadius: "8px", borderTopRightRadius: "8px"}}>
                <div className="flex horizontal mobile-vertical gap-m space-between gap-xl">
                    <Navigate variant="transparent" size="large" href="/">
                        <img src={logo} alt="Materialize Wordmark" className="wordmark-image" onClick={() => navigate("/")} />
                    </Navigate>
                    <div className="flex horizontal flex-1 justify-end mobile-justify-start gap-display">
                        <div className="flex vertical">
                            <div className="flex vertical pad-s">
                                <Text size="title" variant="secondary" bold={true}>Platform</Text>
                            </div>
                            <div className="flex vertical align-start mobile-align-start gap-xs">
                                <Navigate variant="transparent" size="large" href="https://www.trymaterialize.com" newTab={true}>
                                    How it works
                                </Navigate>
                                <Navigate variant="transparent" size="large" href="https://www.trymaterialize.com/sign-up" newTab={true}>
                                    Manufacturer Signup
                                </Navigate>
                                <Navigate variant="transparent" size="large" href="https://app.trymaterialize.com" newTab={true}>
                                    Client Login
                                </Navigate>
                            </div>
                        </div>
                        <div className="flex vertical">
                            <div className="flex vertical pad-s">
                                <Text size="title" variant="secondary" bold={true}>Company</Text>
                            </div>
                            <div className="flex vertical align-start mobile-align-start gap-xs">
                                <Navigate variant="transparent" size="large" href="https://www.trymaterialize.com/contact-us" newTab={true}>
                                    Contact Us
                                </Navigate>
                                <Navigate variant="transparent" size="large" href="https://www.trymaterialize.com/terms-of-use" newTab={true}>
                                    Terms of Use
                                </Navigate>
                                <Navigate variant="transparent" size="large" href="https://www.trymaterialize.com/privacy-policy" newTab={true}>
                                    Privacy Policy
                                </Navigate>
                            </div>
                        </div>
                    </div>
                </div>
                <Divider classes={`${bgColor === "black" ? "on-black-divider" : ""}`} />
                <div className="flex horizontal align-center space-between">
                    <div className="flex vertical">
                        <Text size="caption" variant="secondary" bold={true}>Materialize (Harper AI, Inc.)</Text>
                        <Text size="micro" variant="secondary">1288 McAllister St - San Francisco, CA 94115</Text>
                    </div>
                    <div className="flex horizontal gap-m">
                        <Navigate icon="x-logo" variant="transparent" size="large" href="https://x.com/trymaterialize" newTab={true}/>
                        <Navigate icon="linkedin-logo" variant="transparent" size="large" href="https://www.linkedin.com/company/trymaterialize" newTab={true}/>
                        <Navigate icon="mail-logo" variant="transparent" size="large" href="mailto:info@trymaterialize.com" newTab={true}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SiteFooter;